// extracted by mini-css-extract-plugin
module.exports = {"recommendContent":"index_recommendContent__8ono2","containerClassName":"index_containerClassName__LIx0K","list":"index_list__Bfztr"};